type LoaderArgs = { src: string; width: number; quality?: number };

// Shopify's CDN accepts ?width= and serves WebP/AVIF by content negotiation.
// Anything else (local demo art, SVGs) is served as-is.
export default function imageLoader({ src, width }: LoaderArgs): string {
  if (src.startsWith("https://cdn.shopify.com/")) {
    const url = new URL(src);
    url.searchParams.set("width", String(width));
    return url.toString();
  }
  return src;
}
